import axios from 'axios';
//import usstates from './assets/states';

const urlMLUP = 'api/medicarelookups';
const urlYear = 'api/medicarelookupyears';
const urlPostLead = 'api/medicarelead';
const urlPayers = 'api/getpayers';
const urlZipCodes = 'api/getZipCodeDetails';
const urlPcps = 'api/getPcps';
const urlCodes = 'api/getCodes';
const urlLangCodes = 'api/getLangCodes';

class MedicareLeadsService {
    // get Medicare Lookups
    static getMedicareLookUps() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlMLUP)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getCodes(codeType) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlCodes+'?where={"CodeType":"'+codeType+'"}')
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getPayers() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlPayers+'/')
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getYears() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlYear)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static postMedicareLead(params) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .post(urlPostLead,params)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getZipCodeDetails(zipVal){
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlZipCodes+'?where={"zipCode":"'+zipVal+'"}')
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getPcps(val){
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlPcps+'?where={"pcp":"'+val+'"}')
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getLangCodes(codesArr) {
        let whereObj = {
            codes: []
        };
        if(codesArr.length>0){
            whereObj.codes = codesArr
        }
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlLangCodes+'?where='+JSON.stringify(whereObj))
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
}

export default MedicareLeadsService;
